<script lang="ts" setup>
import {
  AppLink,
} from '#components'

const { loadLayout, layoutData } = useLayout()
await loadLayout()

const { loadIcon } = useDynamicIcons()

function getElement(to: string | null | undefined) {
  return to ? AppLink : 'span'
}
</script>

<template>
  <address
    v-if="layoutData?.contact?.[0]?.Items?.length"
    class="footer-contact"
  >
    <p
      v-for="item in layoutData.contact[0].Items"
      :key="item"
      class="footer-contact__item"
    >
      <component
        :is="getElement(item.Link)"
        :to="item.Link"
        class="footer-contact__link"
      >
        <NuxtIcon
          v-if="item.Icon"
          :name="loadIcon(item.Icon)"
        />
        <span class="footer-contact__label">{{ item.Name }}</span>
      </component>
      <br>
      <span class="footer-contact__description">{{ item.Description }}</span>
    </p>

    <slot />
  </address>
</template>

<style>
@import url("~layers/components/Footer/Contact.css");
</style>
